import Card from '../../../shared/Card';
import { Box, Flex, Grid } from '../../../shared/layouts';
import {
  formatAppointmentDate,
  getReadableDuration
} from '../../../../utils/dateHelpers';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../shared/Button';
import DashIcon from 'imagesUwKluis/svg/dual/dashboard.svg';
import useIconLibrary from "../../../../hooks/useIconLibrary";

const AppointmentCard = ({
  id,
  start_at,
  end_at,
  cobrowse_url,
  onDelete
}) => {
  const { t } = useTranslation();
  const { ForwardIcon } = useIconLibrary();
  const {
    day = '',
    time: startTime = '',
    fullDate: startDate
  } = formatAppointmentDate(start_at);
  const {
    time: endTime = '',
    fullDate: endDate
  } = formatAppointmentDate(end_at);
  const duration = getReadableDuration(startDate, endDate);

  return (
    <Card key={id}>
      <Grid
        gridTemplateColumns={'auto min-content'}
        gridTemplateAreas={{
          mobile: "'time' 'description' 'video' 'actions'",
          tablet: "'time video' 'description actions'"
        }}
        gridRowGap={'m'}
      >
        <Box gridArea={'time'}>
          <Flex
            justifyContent={'center'}
            display={{ mobile: null, tablet: 'none' }}
          >
            <DashIcon height={'96px'} />
          </Flex>
          <Box
            fontScale={'l'}
            fontWeight={'bold'}
            css={{ ':first-letter': { textTransform: 'uppercase' } }}
          >
            {day}
          </Box>
          <Flex mt={'xs'} alignItems={'center'}>
            <Box fontScale={'l'}>
              {`${startTime} - ${endTime} ${t('uur')}`}
            </Box>
            <Box
              ml={'s'}
              fontSize={'xs'}
              lineHeight={'0.75rem'}
              p={'s'}
              backgroundColor={'alertHover'}
              borderRadius={'24px'}
            >
              {duration}
            </Box>
          </Flex>
        </Box>
        {cobrowse_url && (
          <Box
            gridArea={'video'}
            justifySelf={{ mobile: 'start', tablet: 'end' }}
            pb={{ mobile: 'm', tablet: 'none' }}
          >
            <a href={cobrowse_url} target={'_blank'} rel="noreferrer">
              <Button variant={'primary-outline'} width={'216px'}>
                {t('Start videomeeting')}
              </Button>
            </a>
          </Box>
        )}
        <Box gridArea={'description'}>
          <Box flexBasis={'66%'} textAlign={{ sm: 'left', lg: 'left' }}>
            {t('Zorg ervoor dat je goed voorbereid het gesprek in gaat en je alle documenten tijdig in jouw portaal klaar hebt staan.')}
          </Box>
        </Box>
        <Box display={{sm: 'flex', lg: 'block'}} gridArea={'actions'} alignContent={'center'} >
          <Box display={{mobile: 'auto', tablet: 'none'}}>
            <Button
              variant={'anchor'}
              css={{ padding: 0 }}
              onClick={onDelete}
            >
              <Flex alignItems={'center'}>
                {t('Annuleren')}
                <ForwardIcon
                  width={'1.5rem'}
                  height={'1.5rem'}
                  css={({ colors, space }) => ({
                    marginLeft: space.s,
                    fill: colors?.secondary
                  })}
                />
              </Flex>
            </Button>
          </Box>
          <Box marginLeft={'auto'} >
            <Link to={`/calendar/${id}`}>
              <Button
                variant={'anchor'}
                css={{ marginLeft: 'auto', padding: 0, textAlign: 'center' }}
              >
                <Flex alignItems={'center'}>
                  {t('Bewerken')}
                  <ForwardIcon
                    width={'1.5rem'}
                    height={'1.5rem'}
                    css={({ colors, space }) => ({
                      marginLeft: space.s,
                      fill: colors?.secondary
                    })}
                  />
                </Flex>
              </Button>
            </Link>
          </Box>
        </Box>
      </Grid>
    </Card>
  );
};

export default AppointmentCard;
